module.exports = __webpack_public_path__ + "img/society4.986f6253.jpg";